export enum BinaryTokens {
	NullPointer,
	Hole,
	Null,
	PBigInt,
	NBigInt,
	Boolean,
	String,
	Undefined,
	UnsignedByte,
	SignedByte,
	UnsignedInt32,
	SignedInt32,
	UnsignedFloat64,
	SignedFloat64,
	Array,
	EmptyArray,
	ObjectReference,
	Date,
	BooleanObject,
	NumberObject,
	StringObject,
	EmptyObject,
	Object,
	RegExp,
	Map,
	EmptyMap,
	WeakMap,
	Set,
	EmptySet,
	WeakSet,
	ArrayBuffer,
	Int8Array,
	Uint8Array,
	Uint8ClampedArray,
	Int16Array,
	Uint16Array,
	Int32Array,
	Uint32Array,
	Float32Array,
	Float64Array,
	DataView
}

export enum BinaryPrimitives {
	BigInt = 'bigint',
	Boolean = 'boolean',
	Number = 'number',
	Object = 'object',
	String = 'string',
	Undefined = 'undefined'
}

export type TypedArray = Uint8Array | Float32Array | Int32Array;
export const TypedArray = Object.getPrototypeOf(Int8Array) as TypedArray;
